import { InputHTMLAttributes } from 'react';

type QuoteRadioButtonProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> & {
  checked: boolean;
  onChange: () => void;
};

const styles = {
  label: 'relative flex items-center cursor-pointer shrink-0',
  input: 'peer sr-only',
  circle:
    'h-7 w-7 rounded-full border-2 bg-neutral-0 flex items-center justify-center transition-colors peer-focus-visible:outline-3 peer-focus-visible:outline-focus-600',
  circleChecked: 'border-black',
  circleUnchecked: 'border-neutral-400',
  dot: 'h-3.5 w-3.5 rounded-full bg-input-icon-selected',
};

export const QuoteRadioButton = ({ checked, onChange, ...props }: QuoteRadioButtonProps) => (
  <label className={styles.label}>
    <input type="radio" checked={checked} onChange={onChange} className={styles.input} {...props} />
    <span className={`${styles.circle} ${checked ? styles.circleChecked : styles.circleUnchecked}`}>
      {checked && <span className={styles.dot} />}
    </span>
  </label>
);
